<template>
    <div class="messages-system-container">
        <loading
                :active="loading"
                :can-cancel="false"
                loader="dots"
                color="#2292ef"
                :is-full-page="true"
        ></loading>

        <div class="messages-system">
            <offers-list v-model="offerId"></offers-list>
            <div class="messages-pm-box-list">
                <div class="messages-pm-box-head">
                    <p v-if="offer" class="message-username">
                        <a :href="offer.chat_user_url">{{offer.chat_user_full_name}}</a>
                    </p>
                    <p v-if="offer" class="message-subject">
                        <a :href="offer.task.url">{{offer.task.category.title}}</a>
                    </p>
                </div>
                <div class="messages-pm-box-content" id="messagesContainer">
                    <div v-if="offer" class="chatmessage-system">
                        <div class="center">
                            <div class="chat-text">
                <span>
                  {{offer.task.user.name}} created this task on
                  <local-time :time="offer.task.created_at"></local-time>
                </span>
                            </div>
                            <div class="chat-date">
                                <span>{{offer.task.created_at}}</span>
                            </div>
                        </div>
                    </div>

                    <div v-for="(message,index) in messages" :key="index">

                        <div v-if="message.is_system" class="chatmessage-system" style="clear:both !important;">
                            <div class="center">
                                <div class="chat-text">
                <span>
                  {{message.content}}
                  <local-time :time="message.system_date"></local-time>
                </span>
                                </div>
                                <div class="chat-date">
                                    <span>{{message.system_date}}</span>
                                </div>
                            </div>

                        </div>
                        <div v-else
                             :class="{'chatmessage-send':message.sender_id==userId,'chatmessage-recived':message.sender_id!=userId}"
                        >
                            <div
                                    :id="'message-'+message.id"
                                    :class="{'right':message.sender_id==userId,'left':message.sender_id!=userId}"
                            >
                                <div class="chat-text">
                  <span v-if="message.attachment" class="d-flex flex-column align-items-baseline">
                    <img
                            v-if="message.attachment.type.split('/')[0]=='image'"
                            class="m-4"
                            width="200"
                            :src="message.attachment.url"
                    />
                    <a class="ps-btn--sm ps-btn m-4" :href="message.attachment.url" download>
                      <div>
                        <i class="fa fa-paperclip"></i>
                        <span>{{message.attachment.name}}</span>
                        <span>{{parseInt(message.attachment.size / 1024) }} KB</span>
                      </div>
                    </a>
                  </span>
                                    <span>{{message.content}}</span>
                                </div>
                                <div class="chat-date">
                  <span>
                    <local-time :time="message.send_at"></local-time>
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="userWhoIsTypingId" class="typing">Typing...</div>
                <div v-if="attachment">{{attachment.name}}</div>
                <div v-if="offer" class="messages-pm-box-send">
                    <div class="file-box">
                        <label
                                style=""
                                for="file"
                                class="fa fa-paperclip"
                                aria-hidden="true"
                        ></label>
                    </div>
                    <div class="message-box">
                        <input v-on:change="handleFileUpload($event)" type="file" class="d-none" id="file"/>
                        <input
                                class="form-control coustom-searchbox"
                                v-model="message"
                                @keyup.enter="send"
                                @keyup="sendTypingEvent"
                                type="search"
                                placeholder="Type a message"
                        />
                    </div>
                    <div class="send-box">
            <span @click.prevent="send">
              <img src="/assets/images/send.png"/>
            </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    import Swal from "sweetalert2";
    import OffersList from "./OffersList";
    import LocalTime from "./../../LocalTime";

    export default {
        components: {
            Loading,
            OffersList,
            LocalTime
        },
        props: {
            offer_id: {
                type: [String, Number]
            }
        },
        data() {
            return {
                loading: false,
                userId: null,
                offerId: this.offer_id,
                offer: null,
                messages: [],
                message: null,
                attachment: null,
                whisperTimeout: null,
                userWhoIsTypingId: null
            };
        },
        updated() {
            this.goDown();
        },
        created() {
            this.userId = window.user_id;
            let self = this;
            if (self.offerId) {
                Echo.join("offer." + self.offerId)
                    .here(function (users) {
                        // console.log("Here");
                    })
                    .joining(function (user) {
                        // console.log("Joining");
                    })
                    .leaving(user => {
                        // console.log("leaving");
                    })
                    .listenForWhisper("MessageSent", event => {
                        self.messages.push(event.message);
                        axios({
                            method: "post",
                            url:
                                "/api/v1/message/" +
                                event.message.offer.id +
                                "/mark-as-read-messages" +
                                "?api_token=" +
                                window.api_token
                        })
                            .then(res => {
                                if (res.data.ok) {
                                    console.log("read message");
                                }
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    })
                    .listenForWhisper("typing", function (e) {
                        self.userWhoIsTypingId = e.user_id;
                        if (self.whisperTimeout) {
                            clearTimeout(self.whisperTimeout);
                        }
                        self.whisperTimeout = setTimeout(() => {
                            self.userWhoIsTypingId = null;
                        }, 1000);
                    });

                axios({
                    url:
                        "/api/v1/offer/get-offer/" +
                        self.offerId +
                        "?api_token=" +
                        window.api_token
                })
                    .then(res => {
                        if (res.data.ok) {
                            self.offer = res.data.data;
                            self.messages = self.offer.messages;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },
        mounted() {
            let self = this;
            setTimeout(function () {
                if (this.offerId) {
                    this.goDown();
                }
            }, 2000);
        },
        methods: {
            send: function () {
                let self = this;
                self.$Progress.start();
                let data = {
                    message: self.message,
                    offer_id: self.offerId
                };
                if (self.attachment) {
                    data.attachment_id = self.attachment.id;
                }
                axios({
                    method: "post",
                    url: "/api/v1/message/send?api_token=" + window.api_token,
                    data
                })
                    .then(function (response) {
                        self.$Progress.finish();
                        let newMessage = response.data.data;
                        if (self.attachment) {
                            newMessage.attachment = self.attachment;
                        }
                        self.messages.push(newMessage);
                        Echo.join("offer." + self.offer.id).whisper("MessageSent", {
                            message: newMessage
                        });
                        self.message = null;
                        self.attachment = null;
                        self.goDown();
                    })
                    .catch(function (err) {
                        self.$Progress.fail();
                        self.errors = err.response.data.errors;

                        if (err.response.data.type && err.response.data.type === 'messageValidation') {
                            self.$toast.error(err.response.data.msg, {
                                queue: true
                            });
                        }

                        if (self.errors.message) {
                            self.$toast.error("You should type a message", {
                                queue: true
                            });
                        }

                    });
            },
            goDown: function () {
                // console.log("go down");
                // let chat = document.getElementById("scroll-chat");
                // chat.scrollTop = chat.scrollHeight - chat.clientHeight;
                let chat = this.$el.querySelector("#messagesContainer");
                // chat.scrollTop = chat.scrollHeight;
                chat.scrollTop = chat.scrollHeight - chat.clientHeight;
            },
            sendTypingEvent() {
                let self = this;
                Echo.join("offer." + self.offer.id).whisper("typing", {
                    user_id: self.userId
                });
            },
            handleFileUpload: function (event) {
                let data = new FormData();
                data.append("file", event.target.files[0]);
                if (event.target.files[0].size <= 10485760) {
                    let self = this;
                    self.$Progress.start();
                    self.loading = true;
                    axios({
                        method: "post",
                        url: "/api/v1/attachment/upload?api_token=" + window.api_token,
                        data: data,
                        headers: {
                            "Content-Type": `multipart/form-data`
                        }
                    })
                        .then(function (response) {
                            self.$Progress.finish();
                            self.loading = false;
                            self.attachment = response.data.data;
                        })
                        .catch(function (err) {
                            self.$Progress.fail();
                            self.loading = false;
                            self.errors = err.response.data.errors;
                            if (self.errors && self.errors.file) alert(self.errors.file[0]);
                        });
                } else {
                    alert("max file size is 10 MB");
                }
            }
        },
        watch: {
            offerId: {
                handler() {
                    location.href = "/dashboard/message/" + this.offerId;
                }
            }
        }
    };
</script>
